import * as React from "react";
import { Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";
import Progress from "@mui/material/LinearProgress";
/**
 *
 * @param {{ visible: boolean, title: string, rate: number }} props
 * visible: 표시 여부
 * title: 프로그래스바 제목
 * rate: 진행률 (0 ~ 1)
 * @returns
 */
export const ProgressIndeterminate = ({ visible, title, rate }) => {
  const rate100 = rate * 100;
  rate = rate100 > 100 ? 100 : rate100;

  return (
    <Dialog open={visible}>
      <DialogTitle>
        <Typography>{title}</Typography>
      </DialogTitle>
      <DialogContent sx={{width: 400}}>
        <Progress variant="determinate" value={rate} />
      </DialogContent>
    </Dialog>
  );
};
